import React, { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';

import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

type AccountListProps = {
  activeLink: VoidFunction;
};

const AccountAdd: React.FC<AccountListProps> = (props) => {
  const inputNomal = "form-control m-0 pt-1 pb-1";
  const inputInvalid = "form-control m-0 pt-1 pb-1 is-invalid";
  const inputValid = "form-control m-0 pt-1 pb-1 is-valid";

  const [groupId, setGroupId] = React.useState('');
  const [groupName, setGroupName] = React.useState('');
  const [groupIdStyle, setGroupIdStyle] = React.useState(inputNomal);
  const [groupNameStyle, setGroupNameStyle] = React.useState(inputNomal);
  const [groupIdErrValue, setGroupIdErrValue] = React.useState('');
  const [groupNameErrValue, setGroupNameErrValue] = React.useState('');
  const [alertText, setAlertText] = React.useState('');
  const [alertClass, setAlertClass] = React.useState('alert alert-danger d-none');
  const [submitBtnDisable, setDisableSubmitBtn] = useState<boolean>(true);

  useEffect(() => {
    props.activeLink();
  }, [])

  const handleClickBtn = async () => {
    try {
      const sendData = {
        accountId: groupId,
        name: groupName
      };

      const apiName = 'MainApi';
      const path = '/account/';
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
        body: sendData
      };
      const data = await API.post(apiName, path, myInit);
      if (data.accountId !== "" && data.name !== "") {
        setSuccessMessage("グループの追加が完了しました。");
      } else if (data.accountId === "" && data.name === "") {
        setAlertMessage("ACC0301 そのIDと名称は既に使用されています。");
      } else if (data.accountId === "") {
        setAlertMessage("ACC0302 そのIDは既に使用されています。");
      } else if (data.name === "") {
        setAlertMessage("ACC0303 その名称は既に使用されています。");
      } else {
        setAlertMessage("ACC0304 グループの追加に失敗しました。");
      }
    } catch (err) {
      setAlertMessage("ACC0305 グループの追加に失敗しました。");
    }
  }

  const checkInputData = (id: string, name:string) => {
    let idFlg: boolean = false;
    let nameFlg: boolean = false;
    const regexStralphabet = /^[0-9a-zA-Z]*$/;
    if (id.length < 1) {
      setGroupIdStyle(inputInvalid);
      setGroupIdErrValue("NG グループIDは入力必須です");
    } else if (id.length > 8) {
      setGroupIdStyle(inputInvalid);
      setGroupIdErrValue("NG グループIDは8文字以内です");
    } else {
      if (regexStralphabet.test(id)) {
        setGroupIdStyle(inputValid);
        setGroupIdErrValue("");
        idFlg = true;
      } else {
        setGroupIdStyle(inputInvalid);
        setGroupIdErrValue("NG グループIDは半角英数字のみ使用可能です");
      }
    }

    if (name.length < 1) {
      setGroupNameStyle(inputInvalid);
      setGroupNameErrValue("NG グループ名称は入力必須です");
    } else if (name.length > 32) {
      setGroupNameStyle(inputInvalid);
      setGroupNameErrValue("NG グループ名称は32文字以内です");
    } else {
      setGroupNameStyle(inputValid);
      setGroupNameErrValue("");
      nameFlg = true;
    }

    if (idFlg && nameFlg) {
      setDisableSubmitBtn(false);
    } else {
      setDisableSubmitBtn(true);
    }
  }

  const handleChangeId = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGroupId(e.target.value);
    checkInputData(e.target.value,groupName);

  }

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGroupName(e.target.value);
    checkInputData(groupId, e.target.value);
  }

  const setAlertMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-danger');
  }

  const setSuccessMessage = (message: string) => {
    setAlertText(message);
    setAlertClass('alert alert-success');
  }


  return (
    <div className="p-3">

      <h4>グループの追加</h4>
      <div className={alertClass} role="alert">{alertText}</div>
      <div>
        <table className="table table-borderless text-nowrap m-0 p-0" style={{ 'width': '700px' }}>
          <tbody>
            <tr>
              <td className='pt-3 m-0' style={{ 'width': '50px' }}>グループID</td>
              <td className="m-0">
                <div className="form-group m-0 p-0">
                  <input type="text" className={groupIdStyle} value={groupId} onChange={(e) => handleChangeId(e)} required></input>
                  <div className="valid-feedback">
                    {"OK"}
                  </div>
                  <div className="invalid-feedback">
                    {groupIdErrValue}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td className='pt-3 m-0' style={{ 'width': '50px' }}>グループ名称</td>
              <td className="m-0">
                <div className="form-group m-0 p-0">
                  <input type="text" className={groupNameStyle} value={groupName} onChange={(e) => handleChangeName(e)} required></input>
                  <div className="valid-feedback">
                    {"OK"}
                  </div>
                  <div className="invalid-feedback" id={"passInvalid"}>
                    {groupNameErrValue}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div className='form-group m-0 p-0 '>
          <input type="button" className='btn btn-primary' id="addBtn" value={'登録'} onClick={() => handleClickBtn()} disabled={submitBtnDisable}></input>
        </div>
      </div>
    </div>
  );
}

export default AccountAdd;
